import React from 'react';

interface IconProps {
  color?: string;
  size?: number;
}

interface CreateIconOptions {
  viewBox?: string;
  defaultSize?: number;
}

interface IconDataUrlOptions {
  color: string;
  width?: number;
  height?: number;
}

export const createIcon = (path: string, options: CreateIconOptions = {}) => {
  const { viewBox = '0 0 24 24', defaultSize = 24 } = options;

  // The React component that can be used in the UI with theme support
  const IconComponent = ({
    color = 'currentColor',
    size = defaultSize,
  }: IconProps) => (
    <svg width={size} height={size} viewBox={viewBox} fill="none">
      <path d={path} fill={color} />
    </svg>
  );

  // Function to get a data URL for the SVG
  const toDataUrl = ({
    color,
    width = defaultSize,
    height = width,
  }: IconDataUrlOptions) => {
    const svgString = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}" viewBox="${viewBox}" fill="none"><path d="${path}" fill="${color}"/></svg>`;
    const base64 = btoa(unescape(encodeURIComponent(svgString)));
    return `data:image/svg+xml;base64,${base64}`;
  };

  return {
    IconComponent,
    toDataUrl,
  };
};
